import { useMutation } from '@apollo/client';

import {
  UpdateCountryMutation,
  UpdateCountryMutationVariables,
} from '../graphql/generated';
import { UPDATE_COUNTRY } from '../graphql/mutations';

const useUpdateCountry = () => {
  const [updateCountry, result] = useMutation<
    UpdateCountryMutation,
    UpdateCountryMutationVariables
  >(UPDATE_COUNTRY);

  return {
    updateCountry,
    ...result,
  };
};

export default useUpdateCountry;
